export const REELS_EVENTS = {
    "REELS_START": "REELS_START",
    "REELS_COMPLETE": "REELS_COMPLETE",
    "REEL_ACC_UP": "REEL_ACC_UP",
    "REEL_ACC_DOWN": "REEL_ACC_DOWN",
    "REEL_SPIN": "REEL_SPIN",
    "REEL_STOPPING": "REEL_STOPPING",
    "REEL_BRAKEDOWN": "REEL_BRAKEDOWN",
    "REEL_BRAKEUP": "REEL_BRAKEUP",
    "REEL_MOVE": "REEL_MOVE",
    "REEL_STOP": "REEL_STOP",
};